import 'intersection-observer';
import Vue from 'vue';
import App from './App.vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import '@qm-activity/common/assets/styles/reset.css';
import '@q-front-npm/h5-ui/lib/index.css';
import { QToastInstall } from '@q-front-npm/h5-ui/lib/q-toast';
import { polyfillRequestIdleCallback } from '@qm-activity/common/assets/ts/utils';
import debounceClick from '@qm-activity/common/directives/debounce-click';
import stopNativeTouch from '@qm-activity/common/directives/stop-native-touch';
import { initSentry } from '@qm-activity/common/assets/ts/sentry';
import pkg from '../../package.json';

polyfillRequestIdleCallback();
Vue.use(QToastInstall);
Vue.directive('debounce-click', debounceClick);
Vue.directive('stop-native-touch', stopNativeTouch);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
const app = new Vue({
    pinia,
    render: (h) => h(App),
});
initSentry({
    dsn: 'https://f1c3c4083f7848d4acfc7ac7423930f3@qm-front-sentry.wtzw.com/63',
    name: pkg.name,
    version: pkg.version,
});

if (import.meta.env.VITE_ENV !== 'production') {
    import('vconsole').then((res) => {
        new res.default(); // 初始化VConsole实例
        app.$mount('#app');
    });
} else {
    app.$mount('#app');
}
